<div class="zero-balance-modal">
    <mapfre-modal [modalOptions]="zeroBalanceModalOptions" [hideModal]="hideModal"
        (hideModalOutput)="hideModalAction()"
        (click)="hideOnClick($event)">
        <div class="modal-body margin-bottom mb16">
            <div class="margin-top mt24 text-center">
                <div>            
                    <ng-container *ngIf="!isAcmic; else acmicCloseIcon">
                        <img src="./assets/img/images/icon-check-circle-mapfre.svg" alt="check circle icon" />
                    </ng-container>
                    <ng-template #acmicCloseIcon>
                        <img src="./assets/img/images/icon-check-circle-acmic.svg" alt="check circle icon" />
                    </ng-template>           
                </div>
                <h1 class="title-copy mb-3 mt-3"> {{ 'You’re all set' | translate }}</h1>
                <div class="secondary-text margin-bottom mb2 margin-top mt8">{{ 'Your '}}  {{policy?.displayType?.label | titlecase }} - {{policy?.policynumber?.policyNumber}} {{ 'is paid in full, no payment is due at this time.' | translate }}</div>
            </div>
            <hr class="ma-hr-tag margin-top mt32 margin-bottom mb32">
            <div class="row">
                <div class="col display-right">
                    <mapfre-button 
                        additionalClasses="ghost secondary small-btn margin-bottom modal-small-btn"
                        (click)="hideModalAction()"> {{ 'CLOSE' | translate }}
                    </mapfre-button>
                </div>
            </div>
        </div>
    </mapfre-modal>
</div>